import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Axios from "../../axios/axios";
import { dateFormatting,dateFormatForm } from "../utils/Utils";

function EditViewStockPage({
  handleUpdate,
  handleFileChange,
  formData,
  setFormData,
  selectedStock,
  loading,
  loadings,
  fileInput1,
  fileInput2,
  fileInput3,
  product,
}) {
  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...formData.services];
    updatedServices[index] = {
      ...updatedServices[index],
      [field]: value,
    };
    setFormData({ ...formData, services: updatedServices });
  };

  console.log(selectedStock, "selectedStock", product);
  const addService = () => {
    setFormData((prev) => ({
      ...prev,
      services: [
        ...(prev.services || []),
        { date: "", amount: "", note: "", photo: "" },
      ],
    }));
  };

  useEffect(() => {
    getLogs();
  }, []);

  const [logs, setLogs] = useState([]);

  const getLogs = async () => {
    let obj = { product: product, itemCode: selectedStock.itemCode };
    const { data } = await Axios.get(`/api/log/itemcodelogs`, obj);
    setLogs(data?.data);
  };

  return (
    <Container fluid className="py-4">
      <h2 className="mb-4">Stock Information</h2>
      {loading ? (
        <Skeleton height={300} />
      ) : (
        <Tabs defaultActiveKey="edit" className="mb-3" fill>
          {/* Edit Tab */}
          <Tab eventKey="edit" title="Update Stock">
            <Form onSubmit={handleUpdate}>
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Photo 1</Form.Label>
                    <Form.Control
                      type="file"
                      ref={fileInput1}
                      onChange={(e) => handleFileChange(e, "photo1")}
                    />
                    <a
                      href={
                        selectedStock?.photo1 ||
                        process.env.PUBLIC_URL + "/images/select_image.png"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={
                          selectedStock?.photo1 ||
                          process.env.PUBLIC_URL + "/images/select_image.png"
                        }
                        alt="Uploaded"
                        className="img-fluid mt-2"
                        style={{ height: "100px" }}
                      />
                    </a>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Photo 2</Form.Label>
                    <Form.Control
                      type="file"
                      ref={fileInput2}
                      onChange={(e) => handleFileChange(e, "photo2")}
                    />
                    <a
                      href={
                        selectedStock?.photo2 ||
                        process.env.PUBLIC_URL + "/images/select_image.png"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={
                          selectedStock?.photo2 ||
                          process.env.PUBLIC_URL + "/images/select_image.png"
                        }
                        alt="Uploaded"
                        className="img-fluid mt-2"
                        style={{ height: "100px" }}
                      />
                    </a>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Bill Upload</Form.Label>
                    <Form.Control
                      type="file"
                      ref={fileInput3}
                      onChange={(e) => handleFileChange(e, "billUpload")}
                    />
                    <a
                      href={
                        selectedStock?.billUpload ||
                        process.env.PUBLIC_URL + "/images/select_image.png"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={
                          selectedStock?.billUpload ||
                          process.env.PUBLIC_URL + "/images/select_image.png"
                        }
                        alt="Uploaded"
                        className="img-fluid mt-2"
                        style={{ height: "100px" }}
                      />
                    </a>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Purchase Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={formData.purchaseDate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          purchaseDate: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Purchase Cost</Form.Label>
                    <Form.Control
                      type="number"
                      value={formData.purchaseCost}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          purchaseCost: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Warranty Available?</Form.Label>
                    <Form.Select
                      value={formData.warranty}
                      onChange={(e) =>
                        setFormData({ ...formData, warranty: e.target.value })
                      }
                    >
                      <option value="">-- Select --</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Warranty Expiry Date</Form.Label>
                <Form.Control
                  type="date"
                  value={formData.warrantyExpiryDate}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      warrantyExpiryDate: e.target.value,
                    })
                  }
                />
              </Form.Group>

              <Button variant="primary" type="submit">
                {loadings ? <Spinner animation="border" size="sm" /> : "Update"}
              </Button>
            </Form>
          </Tab>

          {/* View Tab */}
          <Tab eventKey="view" title="View Stock">
            {selectedStock && (
              <div className="p-3 border rounded">
                <p>
                  <b>Item Code:</b> {selectedStock.itemCode}
                </p>
                <p>
                  <b>Serial Number:</b> {selectedStock.serialNumber}
                </p>
                <p>
                  <b>Photo 1:</b>{" "}
                  <img
                    src={selectedStock.photo1}
                    alt="Photo 1"
                    style={{ maxWidth: "100px" }}
                  />
                </p>
                <p>
                  <b>Photo 2:</b>{" "}
                  <img
                    src={selectedStock.photo2}
                    alt="Photo 2"
                    style={{ maxWidth: "100px" }}
                  />
                </p>
                <p>
                  <b>Bill Upload:</b>{" "}
                  <img
                    src={selectedStock.billUpload}
                    alt="Bill"
                    style={{ maxWidth: "100px" }}
                  />
                </p>
                <p>
                  <b>Purchase Date:</b> {dateFormatForm(selectedStock.purchaseDate)}
                </p>
                <p>
                  <b>Purchase Cost:</b> ₹{selectedStock.purchaseCost}
                </p>
                <p>
                  <b>Warranty:</b> {selectedStock.warranty ? "Yes" : "No"}
                </p>
                <p>
                  <b>Warranty Expiry:</b>{" "}
                  {new Date(
                    selectedStock.warrantyExpiryDate
                  ).toLocaleDateString()}
                </p>

                {selectedStock.services?.length > 0 && (
                  <>
                    <h5 className="mt-4">Services</h5>
                    {selectedStock.services.map((s, idx) => (
                      <div key={idx} className="bg-light p-2 mb-2 rounded">
                        <p>
                          <b>Date:</b> {new Date(s.date).toLocaleDateString()}
                        </p>
                        <p>
                          <b>Cost:</b> ₹{s.amount}
                        </p>
                        <p>
                          <b>Note:</b> {s.note || "—"}
                        </p>
                        <p>
                          <b>Photo:</b>{" "}
                          {s.photo ? (
                            <img
                              src={s.photo}
                              alt="Service"
                              style={{ maxWidth: "100px" }}
                            />
                          ) : (
                            "No photo"
                          )}
                        </p>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          </Tab>

          {/* Service CRUD */}
          <Tab eventKey="service" title="Service">
            <Form>
              {formData.services?.map((service, index) => (
                <div key={index} className="border p-3 mb-3 rounded">
                  <Form.Group>
                    <Form.Label>Service Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={service.date}
                      onChange={(e) =>
                        handleServiceChange(index, "date", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Service Cost</Form.Label>
                    <Form.Control
                      type="number"
                      value={service.amount}
                      onChange={(e) =>
                        handleServiceChange(index, "amount", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Note</Form.Label>
                    <Form.Control
                      type="text"
                      value={service.note}
                      onChange={(e) =>
                        handleServiceChange(index, "note", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Service Photo</Form.Label>
                    <Form.Control
                      type="file"
                      onChange={(e) =>
                        handleFileChange(e, "photo", index, true)
                      }
                    />
                    <a
                      href={
                        service.photo ||
                        process.env.PUBLIC_URL + "/images/select_image.png"
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={
                          service.photo ||
                          process.env.PUBLIC_URL + "/images/select_image.png"
                        }
                        alt="Service"
                        className="img-fluid mt-2"
                        style={{ height: "100px" }}
                      />
                    </a>
                  </Form.Group>

                  <Button
                    className="mt-2"
                    variant="success"
                    onClick={handleUpdate}
                  >
                    Save Service
                  </Button>
                </div>
              ))}
              <Button onClick={addService}>Add Service</Button>
            </Form>
          </Tab>

          {/* ✅ New Logs Tab */}
          <Tab eventKey="logs" title="Logs">
            <div
              style={{ maxHeight: "300px", overflow: "auto" }}
              className="mt-3"
            >
              <table className="table table-bordered table-sm">
                <tbody>
                  {logs?.length > 0 ? (
                    logs.map((data, idx) => (
                      <tr key={idx}>
                        <td>
                          <span style={{ color: "red" }}>
                            {data.user?.name}
                          </span>
                          &nbsp; [ {data.user?.address1} ] &nbsp;
                          {data.action}
                          {data.action === "ORDER PLACED" && (
                            <span>
                              {" "}
                              FOR <b>
                                {dateFormatting(data.startDate)}
                              </b> To <b>{dateFormatting(data.endDate)}</b>
                            </span>
                          )}
                          &nbsp; AT {dateFormatting(data.createdAt)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>No logs found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Tab>
        </Tabs>
      )}
    </Container>
  );
}

export default EditViewStockPage;
